var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-banner-user"},[_c('div',{staticClass:"user-inner"},[(_vm.authUser.user === null)?_c('div',{staticClass:"inner-guest"},[_c('span',{staticClass:"gradient-green"},[_vm._v("SIGN IN TO START")]),_c('AuthButton')],1):_c('div',{staticClass:"inner-auth",class:[
            'auth-' + _vm.homeGetLevelColor
        ]},[_c('span',{staticClass:"gradient-green"},[_vm._v("BLOXIFY LAUNCHED VERSION 1.0")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }